import { graphql, useStaticQuery } from "gatsby"

export interface PartnerImage {
  name: string;
  srcSet: string[];
  alt: string;
  fluid: {};
}

export const usePartnerImages: (page?: string) => PartnerImage[] = () => {
  const { allFile, site } = useStaticQuery(
    graphql`
        query PartnerImages {
            allFile(filter: {relativeDirectory: {eq: "partners"}}) {
                nodes {
                    childImageSharp {
                        fluid(jpegQuality: 80, pngQuality: 80) {
                            srcSet
                            originalName
                            ...GatsbyImageSharpFluid
                        }
                    }
                }
            }
            site {
                siteMetadata {
                    title
                }
            }
        }
    `
  )

  return allFile.nodes.map(node => (
    {
      name: node.childImageSharp.fluid.originalName.split(".")[0],
      srcSet: node.childImageSharp.fluid.srcSet,
      fluid: node.childImageSharp.fluid,
      alt: `${site.siteMetadata.title} ${node.childImageSharp.fluid.originalName.split(".")[0]} image`
    } as PartnerImage)
  )
}
